
import BaseStore from 'stores/BaseStore';

class RewardStore extends BaseStore {
  constructor() {
    super('rewards', 'reward', { site_model: true });
  }
}

export default new RewardStore();
